/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/label-has-associated-control */

// React
import React, { useState, useEffect } from 'react';

// utils
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { useDispatch, useSelector } from 'react-redux';

// Components
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { ADGMBreadcrumbs, CancelApplicationModalV2, ADGMImage } from 'aurora-components';
import { fetchWallet } from 'aurora-composition/modules/wallet/actions';
import PaymentMethod from './PaymentMethod';
import PaymentDetails from './PaymentDetails';

// styles
import styles from './styles';

function Payment(props) {
  const {
    classes,
    children,
    breadCrumbs,
    balance,
    breakdown,
    property,
    paymentHandler,
    Showtopbar,
    terminateApplicationHandler,
    paymentData,
    application,
    ShowApplicationHeader,
    componentUnderBreadCrumb,
    disableWallet,
    cardOnlyService,
    disableWalletMessage,
  } = props;
  const dispatch = useDispatch();
  const { walletError } = useSelector(state => state.walletReducer);

  const [lowBalance, setLowBalance] = useState(false);
  const [walletActive, setWalletActive] = useState(false);
  const [cardActive, setCardActive] = useState(true);
  const [isModalOpenApplicationReject, setModalOpenApplicationReject] = useState(false);

  const toggleModalApplicationReject = () => {
    setModalOpenApplicationReject(!isModalOpenApplicationReject);
  };
  const locale = localStorage.getItem('lang');
  useEffect(() => {
    if (breakdown) {
      const islowBalance = balance < breakdown?.totalAmount;
      setLowBalance(islowBalance);
    }
  }, [breakdown, balance]);

  const payNowHanlder = () => {
    if (walletActive) {
      paymentHandler('WALLET');
    } else {
      paymentHandler('CARD');
    }
  };

  const creditCardHandler = () => {
    setCardActive(true);
    setWalletActive(false);
  };
  const walletHandler = () => {
    setWalletActive(true);
    setCardActive(false);
  };

  useEffect(() => {
    dispatch(fetchWallet());
  }, []);

  const SHOULD_SHOW_CANCEL_BUTTON =
    application?.applicationDetails?.canCancel && typeof terminateApplicationHandler === 'function';

  return (
    <div className={classes.main}>
      <Container className={classes.container}>
        <Hidden mdDown>
          <div className={classes.breadcrumbsHolder}>
            <ADGMBreadcrumbs paths={breadCrumbs} />
            {application?.applicationType !== 'PMA_REGISTRATION' && (
              <Typography className={classes.serviceid}>
                {keyEmptyCheck('Application_ID')} :{' '}
                <strong>{application?.applicationDetails?.applicationNumber || application?.applicationNumber}</strong>
              </Typography>
            )}
          </div>
        </Hidden>
        <Grid container className={classes.extraComponentContainer}>
          <Grid item xs={12} md={8}>
            {componentUnderBreadCrumb}
          </Grid>
        </Grid>
        <Hidden mdUp>
          <div className={classes.mobileTitlehead}>
            <div>
              <Link href='/app/applications'>
                <ADGMImage name='croseblackonmobile.svg' alt='croseimg' />
                {keyEmptyCheck('payment_summary')}
              </Link>
            </div>
            {terminateApplicationHandler && (
              <Button className={classes.terminateBtnMobile} onClick={toggleModalApplicationReject}>
                <ADGMImage name='Trash.svg' alt='trash' />
              </Button>
            )}
          </div>
        </Hidden>
        {property && Showtopbar && (
          <Grid container spacing={3} className={classes.propertyContainer} alignItems='center'>
            <Grid item xs={12} md={8} className={classes.propertyItemContainer}>
              <ADGMImage alt='Image2' name='offPlan1x.svg' />

              <div className={classes.plotNumberContainer}>
                <Typography variant='h6' component='h1'>
                  {keyEmptyCheck('plot_number')}:{property?.plotNumber}
                </Typography>
                <Typography variant='body1'>
                  {locale === 'ar'
                    ? property?.districtAr + ',' + property?.communityAr
                    : property?.districtEn + ', ' + property?.communityEn}
                </Typography>
              </div>
            </Grid>
          </Grid>
        )}

        {ShowApplicationHeader && (
          <Grid container spacing={3}>
            <Grid item xs={12} md={8} className={classes.applicationHeader}>
              <Hidden mdDown>
                <Typography variant='h6' component='h1'>
                  {keyEmptyCheck(application?.applicationType || application?.applicationDetails?.applicationType)}
                </Typography>
              </Hidden>
              {/* <Typography variant="body1">
                {keyEmptyCheck("Application_ID")}: {application?.applicationDetails?.applicationNumber}
              </Typography> */}
            </Grid>
          </Grid>
        )}
        {/* {ShowApplicationHeader && application?.applicationType === 'PMA_REGISTRATION' && (
          <Grid container spacing={3}>
            <Grid item xs={12} md={8} className={classes.headerV2}>
              <div>
                <ADGMImage name='Company_avatar.svg' alt='company' className={classes.headerLogo} aria-hidden='true' />
              </div>
              <div className={classes.headerContentV2}>
                <Typography variant='h6' component='h1' className={classes.TitleV2}>
                  {application?.applicationDetails?.applicationNumber}
                </Typography>
                <Typography variant='body1' className={classes.subTitle}>
                  {keyEmptyCheck('pma_classification')}
                </Typography>
              </div>
            </Grid>
          </Grid>

        )}{' '} */}
        <Grid container spacing={3} className={classes.gridContainer}>
          <Grid item xs={12} md={8}>
            {children}
          </Grid>
          <Grid item xs={12} md={4}>
            {!cardOnlyService && 

            <PaymentMethod
              classes={classes}
              balance={balance}
              lowBalance={lowBalance}
              cardActive={cardActive}
              walletActive={walletActive}
              walletHandler={walletHandler}
              creditCardHandler={creditCardHandler}
              disableWallet={disableWallet}
              disableWalletMessage={disableWalletMessage}
              hideWallet={walletError?.statusCode !== '100033'}
            />
          }
            <PaymentDetails classes={classes} breakdown={paymentData} payNowHanlder={payNowHanlder} />
            {terminateApplicationHandler && (
              <div className={classes.terminateBtnContainer}>
                {SHOULD_SHOW_CANCEL_BUTTON && (
                  <Button
                    variant='text'
                    className={classes.cancelApplicationbtn}
                    onClick={toggleModalApplicationReject}
                  >
                    <ADGMImage name='trash_red.svg' alt='trash' />
                    {keyEmptyCheck('cancel_application')}
                  </Button>
                )}
              </div>
            )}
          </Grid>
        </Grid>

        <CancelApplicationModalV2
          open={isModalOpenApplicationReject}
          onClose={toggleModalApplicationReject}
          toggleModal={toggleModalApplicationReject}
          cancelApplication={terminateApplicationHandler}
        />
      </Container>
    </div>
  );
}

Payment.propTypes = {
  classes: PropTypes.object.isRequired,
  paymentData: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  breadCrumbs: PropTypes.array.isRequired,
  balance: PropTypes.string.isRequired,
  paymentHandler: PropTypes.func.isRequired,
  breakdown: PropTypes.object.isRequired,
  property: PropTypes.object.isRequired,
  terminateApplicationHandler: PropTypes.func,
  Showtopbar: PropTypes.bool.isRequired,
  application: PropTypes.object,
  ShowApplicationHeader: PropTypes.bool,
  componentUnderBreadCrumb: PropTypes.node,
  disableWallet: PropTypes.bool,
  disableWalletMessage: PropTypes.string,
  cardOnlyService: PropTypes.bool,
};

Payment.defaultProps = {
  terminateApplicationHandler: null,
  application: {},
  ShowApplicationHeader: false,
  componentUnderBreadCrumb: null,
  disableWallet: false,
  disableWalletMessage: '',
  cardOnlyService: false,
};

export default withStyles(styles)(Payment);
